const scrollTo = (e, href) => {
  e.preventDefault();
  document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
};

export default function Footer() {
  return (
    <footer className="bg-brand-deep pt-24 text-ivory" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid gap-14 pb-20 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <p className="font-serif text-6xl font-medium tracking-tight sm:text-7xl">
              OravioCare
            </p>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-ivory/60">
              The global medical concierge for patients from the US, UK and Europe — world-class
              treatment in India at an honest, all-inclusive price.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">Explore</p>
            <ul className="mt-5 space-y-3 text-sm">
              {[
                ["Treatments", "#treatments", "footer-treatments-link"],
                ["Patient journey", "#journey", "footer-journey-link"],
                ["Get a free quote", "#quote", "footer-quote-link"],
              ].map(([label, href, id]) => (
                <li key={href}>
                  <a href={href} data-testid={id} onClick={(e) => scrollTo(e, href)} className="text-ivory/70 transition-colors duration-300 hover:text-gold">
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">Concierge desk</p>
            <ul className="mt-5 space-y-3 text-sm text-ivory/70">
              <li>
                <a href="tel:+918421559637" data-testid="footer-phone" className="transition-colors duration-300 hover:text-gold">Care line · +91 84215 59637</a>
              </li>
              <li>
                <a href="mailto:help@oraviocare.in" data-testid="footer-email" className="transition-colors duration-300 hover:text-gold">help@oraviocare.in</a>
              </li>
              <li className="pt-2 font-mono text-[10px] uppercase tracking-[0.2em] text-ivory/40">
                24/7 patient emergency line for travelling guests
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col gap-4 border-t border-ivory/10 py-8 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-5">
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-ivory/40">
              © 2026 OravioCare Health Pvt. Ltd. · Pune
            </p>
            <a href="/admin/login" data-testid="footer-admin-link" className="font-mono text-[10px] uppercase tracking-[0.2em] text-ivory/40 transition-colors duration-300 hover:text-gold">
              Admin sign-in
            </a>
          </div>
          <p className="max-w-xl text-[11px] leading-relaxed text-ivory/35">
            OravioCare is a medical travel facilitator, not a medical provider. All treatment decisions
            are made between you and your treating physician. Prices shown are indicative packages.
          </p>
        </div>
      </div>
    </footer>
  );
}
